/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneArticleTeaserBodytext from 'sites/allas/components/standalone/ArticleTeaser/Bodytext';

export const DynamicStandaloneArticleTeaserBodytext = StandaloneArticleTeaserBodytext;
export type DynamicStandaloneArticleTeaserBodytextProps = PropsFromComponent<typeof StandaloneArticleTeaserBodytext>;

export const DynamicStandaloneArticleTeaserBodytextWith = (extras: DynamicStandaloneExtras): typeof StandaloneArticleTeaserBodytext => {
    return function DynamicStandaloneArticleTeaserBodytext(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticleTeaserBodytext');
        return <StandaloneArticleTeaserBodytext {...mergeProps({ options: { theme } }, props)} />;
    }
}